import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsRewindIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M1.28 11.96L11.44 4.96V10.92L20.3 4.96V18.96L11.44 13V18.96L1.28 11.96ZM4.18 11.96L9.82 15.82V8.1L4.18 11.96ZM12.76 11.96L18.68 15.8V8.12L12.76 11.96Z" />
    </SvgIcon>
  );
});
